import { createUseStyles } from "react-jss";
import { breakpoints } from "../../constants/breakpoints";
import { colors } from "../../constants/colors";


const styles = createUseStyles(theme => ({
  navigation: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.navigation.backgroundColor,
    position: "fixed",
    left: "0",
    right: "0",
    width: "280px",
    height: "100%",
    fontSize: "16px",
    fontWeight: "600",
    '-webkit-font-smoothing': 'antialiased',
    lineHeight: "24px",
    borderRight: theme.navigation.borderRight,
    overflow: "auto",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      position: "relative",
      // height: "64px",
      width: "100%",
      borderBottom: "1px solid " + colors.lightGrey,
      overflow: "visible",
      backgroundColor: theme.navigation.mobile.backgroundColor
    },
  },
  bannerPresent: {
    height: "93%",
  },
  menuItems: {
    backgroundColor: theme.navigation.backgroundColor,
    width: "100%",
    overflow: "auto",
    zIndex: 5,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      position: "absolute",
      top: "66px",
      height: "calc(100dvh - 66px)",
      overflow: "visible",
      backgroundColor: theme.navigation.mobile.backgroundColor,
      paddingBottom:`env(safe-area-inset-bottom, 0)`
    },
  },
  menuItemsBannerPresent: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      height: "calc(100vh - 130px)",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      height: "calc(100vh - 150px)",
    },
  },
  divider: {
    width: "100%",    
    color: colors.gray200,
    marginTop: 0,
    marginBottom: "24px",
    opacity: 1,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "none",
    },  
  },
}));

export default styles;